/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseData } from './genericApiResponseData';
import type { GenericApiResponseMessage } from './genericApiResponseMessage';
import type { GenericApiResponsePagination } from './genericApiResponsePagination';
import type { GenericApiResponseError } from './genericApiResponseError';

/**
 * API response that can represent either success or error state.

The response follows REST best practices:
1. Success responses contain data and optional metadata
2. Error responses contain error details
3. HTTP status codes are determined from error definitions
 */
export interface GenericApiResponse {
  data?: GenericApiResponseData;
  message?: GenericApiResponseMessage;
  pagination?: GenericApiResponsePagination;
  error?: GenericApiResponseError;
  statusCode?: number;
}
